export enum SezzleDirectoryEndpoint {
  SearchURL = 'v2/stores/search',
  SuggestionURL = 'v2/stores/suggestion',
  ClickURL = 'v2/stores/click',
}
